import { MouseEvent, ReactNode, useState } from 'react';

import { Button, Menu, MenuItem } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'components/common/Link';
import { marketObjects, markets } from 'constants/markets';
import useMarket from 'stores/useMarket';

export default function LanguageSelector({ icon }: { icon?: ReactNode }) {
    const { displayName } = useMarket((state) => state);
    const [anchorEl, setAnchorEl] = useState<null | HTMLButtonElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (
        <>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                endIcon={icon}
            >
                {displayName}
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ 'aria-labelledby': 'basic-button' }}
            >
                {marketObjects.map(({ market: currentMarket, displayName: currentDisplayName }) => (
                    <MenuItem key={currentMarket} itemID={currentMarket} onClick={handleClose}>
                        <ListItemText>
                            <Link locale={markets[currentMarket].locale} href="/" style={{ display: 'block', color: '#000' }}>
                                {currentDisplayName}
                            </Link>
                        </ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
